const modifierKeys = ["ctrlKey", "metaKey", "altKey", "shiftKey"];
const isModifiedClickEvent = (e) => modifierKeys.some((key) => key in e && e[key]);
export {
  isModifiedClickEvent
};
//# sourceMappingURL=is-modified-click-event.js.map
